(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('LenderDetailController', LenderDetailController);

    LenderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Lender', 'Address'];

    function LenderDetailController($scope, $rootScope, $stateParams, entity, Lender, Address) {
        var vm = this;

        vm.lender = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:lenderUpdate', function(event, result) {
            vm.lender = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
